
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateExpensePaymentMethodDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    offsetLedgerAccountId: new FormControl<number | undefined>(undefined),
    createsOpenItem: new FormControl<boolean | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
    sortOrder: new FormControl<number | undefined>(undefined),
})
;
}
      